requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('variant-selects')) {
      class VariantSelects extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.querySelectorAll('input[type="radio"]').forEach(input => input.checked = input.hasAttribute('checked'));
          this.product = this.closest('.product');
          this.updateOptions();
          this.previousOptions = [...this.options];
          this.addEventListener('change', this.onVariantChange);

          scriptController.scripts.push('product-variants.js');
        }

        onVariantChange(settings = {}) {
          this.productForm = this.closest('.product, .card-wrapper').querySelector('product-form');

          if (!this.productForm) return;

          this.updateOptions();
          if (this.shouldAutoSelectVariant(settings)) {
            this.autoSelectVariantFromFirstOption();
            this.updateOptions();
          }
          this.changeLabelValue();
          this.updateMasterId();
          this.updateVariantProductAttribute();
          this.updatePickupAvailability();
          this.removeErrorMessage();
          this.removeActiveMedia();
          this.updateVariantStatuses();

          if (!this.currentVariant) {
            this.productForm.toggleAddButton(true, '', true);
            this.setUnavailable();
          } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput(settings);
            this.updateSellingPlansUI();
            this.renderProductInfo();
            this.updateShareUrl();
          }

          this.updateThumbnailSlider();

          this.productForm.classList.add('variant-selects--changed');
          this.previousOptions = [...this.options];
        }

        updateOptions(options) {
          this.options = options || Array.from(this.querySelectorAll('select'), (select) => select.value);
        }

        changeLabelValue() {
          const selectedValueLabel = this.querySelectorAll('[data-selected-value]');
          if (!selectedValueLabel.length) return;
          this.options.forEach((optionValue, index) => selectedValueLabel[index].innerHTML = optionValue);
        }

        shouldAutoSelectVariant(settings = {}) {
          if (settings.isFootbar) return false;
          if (!this.options || this.options.length < 2) return false;
          if (!this.previousOptions || this.previousOptions.length < 2) return false;

          return this.options[0] !== this.previousOptions[0];
        }

        autoSelectVariantFromFirstOption() {
          const variant = this.findVariantFromFirstOption();

          if (variant) this.changeOptions(variant.options);
        }

        findVariantFromFirstOption() {
          const firstOption = this.options && this.options[0];

          if (!firstOption) return null;

          const variants = this.getVariantData().variants.filter((variant) => variant.option1 === firstOption);

          return variants.find((variant) => variant.available) || variants[0] || null;
        }

        changeOptions(options) {
          const selects = this.querySelectorAll('select');

          options.forEach((optionValue, index) => {
            const options = selects[index].querySelectorAll('option');

            options.forEach(option => {
              option.selected = option.value === optionValue;
            });
          });
        }

        updateMasterId() {
          this.currentVariant = this.getVariantData().variants.find((variant) => {
            return !variant.options.map((option, index) => {
              return this.options[index] === option;
            }).includes(false);
          });
        }

        removeActiveMedia() {
          const mediaGalleries = this.product?.querySelector('media-gallery');

          if (!mediaGalleries) return;

          mediaGalleries.classList.remove('has-active');
        }

        updateMedia() {
          if (!this.currentVariant) return;
          if (!this.currentVariant.featured_media) return;

          let mediaGalleries;

          if (this.product) {
            mediaGalleries = this.product.querySelectorAll('media-gallery');

            if (!mediaGalleries.length) {
              mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
            }

            if (mediaGalleries.length) {
              mediaGalleries.forEach((mediaGallery) => {
                if (window.groupGallery) {
                  mediaGallery.querySelectorAll('slider-component').forEach(slider => {
                    slider.resetPages();
                  });
                  mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !window.groupGallery);
                } else {
                  mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !window.groupGallery)
                }
              });
            }

            const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
            if (modalContent) {
              const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
              modalContent.prepend(newMediaModal);
            }
          }
        }

        updateThumbnailSlider() {
          if (!window.groupGallery) return;
          if (!this.product) return;

          const thumbnailSlider = this.product.querySelector('.thumbnail-slider');

          if (!thumbnailSlider) return;

          thumbnailSlider.resetPages();
        }

        updateURL() {
          if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
          window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        updateShareUrl() {
          const shareButton = document.getElementById(`Share-${this.dataset.section}`);
          if (!shareButton) return;

          scriptController.executeWhenScriptLoaded(['share.js'], () => {
            shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
          });
        }

        updateVariantInput(settings) {
          const productForms = this.productForm.dataset.productType === 'card' ? [this.closest('form')] : document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);

          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          });

          if (this.productForm.dataset.productType !== 'card' && !settings.isFootbar) {
            const footbarProductForm = document.getElementById(`product-form-${this.dataset.section}-footbar`);

            if (footbarProductForm) {
              scriptController.executeWhenScriptLoaded(['animated-dropdown.js'], () => {
                const footbarInput = footbarProductForm.querySelector('select[name="id"]');
                footbarInput.value = this.currentVariant.id;
                footbarInput.dispatchEvent(new Event('change', {
                  bubbles: true
                }));
              });
            }
          }
        }

        updateVariantStatuses() {
          const selectedOptionOneVariants = this.variantData.variants.filter(
            (variant) => this.querySelector(':checked').value === variant.option1
          );
          const inputWrappers = [...this.querySelectorAll('.product-form__input')];
          inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants
              .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
              .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
          });
        }

        setInputAvailability(elementList, availableValuesList) {
          elementList.forEach((element) => {
            const value = element.getAttribute('value');
            const availableElement = availableValuesList.includes(value);

            if (element.tagName === 'INPUT') {
              element.classList.toggle('disabled', !availableElement);
            } else if (element.tagName === 'OPTION') {
              element.innerText = availableElement ?
                value :
                window.variantStrings.unavailable_with_option.replace('[value]', value);
            }
          });
        }

        updateVariantProductAttribute() {
          if (!this.product) return;
          if (this.currentVariant) {
            this.product.setAttribute('data-selected-variant-id', this.currentVariant.id);
          } else {
            this.product.removeAttribute('data-selected-variant-id');
          }
        }

        updatePickupAvailability() {
          const pickUpAvailability = document.querySelector('pickup-availability');
          if (!pickUpAvailability) return;

          if (this.currentVariant && this.currentVariant.available) {
            scriptController.executeWhenScriptLoaded(['pickup-availability.js'], () => {
              pickUpAvailability.fetchAvailability(this.currentVariant.id);
            });
          } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
          }
        }

        removeErrorMessage() {
          if (customElements.get('product-form')) {
            this.productForm.onError();
          }
        }

        renderProductInfo() {
          if (customElements.get('product-form')) {
            this.productForm.toggleProductLoading({
              isLoading: true,
              processForm: true,
              processButton: false
            });
          }

          if (this.productForm.dataset.productType === 'card') {
            fetch(`${this.dataset.url}${this.dataset.url.indexOf('?') === -1 ? '?' : '&'}variant=${this.currentVariant.id}&view=product-cart`)
              .then((response) => response.text())
              .then((responseText) => {
                const product = this.closest('.card-wrapper');
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const mediaDestination = product.querySelector('.media');
                const mediaSource = html.querySelector('.media');
                const priceDestination = product.querySelector('.card-information__price');
                const priceSource = html.querySelector('.card-information__price');
                const badgeDestination = product.querySelector('.card__badge');
                const badgeSource = html.querySelector('.card__badge');
                const CustomBadgesDestination = product.querySelector('.custom-badges');
                const CustomBadgesSource = html.querySelector('.custom-badges');

                const processContent = () => {
                  if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
                  if (badgeSource && badgeDestination) badgeDestination.innerHTML = badgeSource.innerHTML;
                  if (badgeDestination) badgeDestination.classList.remove('visibility-hidden');
                  if (CustomBadgesSource && CustomBadgesDestination) CustomBadgesDestination.innerHTML = CustomBadgesSource.innerHTML;

                  const price = product.querySelector('.card-information__price');

                  if (price) price.classList.remove('visibility-hidden');
                  if (this.currentVariant && this.productForm.toggleAddButton) this.productForm.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, false, !this.currentVariant.available);

                  if (customElements.get('product-form')) {
                    this.productForm.toggleProductLoading({
                      isLoading: false
                    });
                  }
                };

                if (mediaSource && mediaDestination) {
                  mediaDestination.classList.remove('media--loaded');
                  const mediaWrapper = document.createElement('div');

                  mediaWrapper.innerHTML = mediaSource.innerHTML;

                  const mediaImage = mediaWrapper.querySelector('img');

                  mediaImage.style = 'visibility: hidden;';
                  mediaImage.addEventListener('load', () => {
                    mediaImage.style = '';
                    mediaDestination.querySelectorAll('img').forEach((element, index) => {
                      if (element.dataset.master !== mediaImage.dataset.master && index > 0) {
                        element.remove();
                        element = null;
                      }
                    });

                    processContent();
                  });
                  mediaDestination.insertBefore(mediaImage, mediaDestination.firstChild);
                } else {
                  processContent();
                }
              });
          } else {
            const isQuickView = this.dataset.section.indexOf('quickadd-template') !== -1;
            const sectionIdParam = !isQuickView ? `&section_id=${this.dataset.section}` : '';

            fetch(`${this.dataset.url}?variant=${this.currentVariant.id}${sectionIdParam}`)
              .then((response) => response.text())
              .then((responseText) => {
                const priceId = `price-${this.dataset.section}`;
                const skuId = `Sku-${this.dataset.section}`;
                const stockId = `stock-${this.dataset.section}`;
                const CustomBadgesId = `CustomBadges-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                if (isQuickView) {
                  const productElement = html.querySelector('section[id^="MainProduct-"]');
                  const sectionId = productElement.dataset.section;

                  productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
                }

                const priceDestination = document.getElementById(priceId);
                const priceSource = html.getElementById(priceId);
                const skuDestination = document.getElementById(skuId);
                const skuSource = html.getElementById(skuId);
                const stockDestination = document.getElementById(stockId);
                const stockSource = html.getElementById(stockId);
                const CustomBadgesDestination = document.getElementById(CustomBadgesId);
                const CustomBadgesSource = html.getElementById(CustomBadgesId);
                const inventorySource = html.getElementById(
                  `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
                if (skuSource && skuDestination) skuDestination.innerHTML = skuSource.innerHTML;
                if (stockSource && stockDestination) stockDestination.innerHTML = stockSource.innerHTML;
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (CustomBadgesSource && CustomBadgesDestination) CustomBadgesDestination.innerHTML = CustomBadgesSource.innerHTML;

                const price = document.getElementById(`price-${this.dataset.section}`);
                const sku = document.getElementById(`Sku-${this.dataset.section}`);
                const stock = document.getElementById(`stock-${this.dataset.section}`);

                if (price) price.classList.remove('visibility-hidden');
                if (sku) sku.classList.remove('visibility-hidden');
                if (stock) stock.classList.remove('visibility-hidden');
                if (stock) stock.classList[!stock.querySelector('.product__stock-content') ? 'add' : 'remove']('hidden');
                if (inventorySource && inventoryDestination)
                  inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

                if (this.currentVariant && this.productForm.toggleAddButton) this.productForm.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, false, !this.currentVariant.available);


                if (customElements.get('product-form')) {
                  this.productForm.toggleProductLoading({
                    isLoading: false
                  });
                }
              });
          }
        }

        setUnavailable() {
          const button = this.productForm.dataset.productType === 'card' ? this.closest('form') : document.getElementById(`product-form-${this.dataset.section}`);
          const addButton = button.querySelector('[name="add"]');
          const addButtonText = button.querySelector('[name="add"] > span');
          let price;

          if (this.productForm.dataset.productType === 'card') {
            const productForm = this.closest('.product-form');

            if (productForm) {
              price = productForm.querySelector('.card-information__price');
            }
          } else {
            price = document.getElementById(`price-${this.dataset.section}`);
          }

          if (!addButton) return;
          addButtonText.innerHTML = window.variantStrings.unavailable;
          if (price) price.classList.add('visibility-hidden');

          if (this.productForm.dataset.productType === 'card') {
            const product = this.closest('product-form');
            const badge = product.querySelector('.card__badge');

            if (badge) badge.classList.add('visibility-hidden');
          }
        }

        getVariantData() {
          this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
          return this.variantData;
        }

        updateSellingPlansUI() {
          this.sellingPlanGroups = this.sellingPlanGroups || this.productForm.querySelectorAll('.product-form__selling-plans fieldset');

          if (!this.sellingPlanGroups.length) return;

          const allowedGroups = (this.currentVariant.selling_plan_allocations || [])
            .map(a => a.selling_plan_group_id);

          this.sellingPlanGroups.forEach(group => {
            const groupId = group.getAttribute('data-selling-plan-group-id');
            const isAllowedGroup = allowedGroups.includes(groupId);
            const inputs = group.querySelectorAll('[name="selling_plan"]');

            group.classList.toggle('hidden', !isAllowedGroup);

            if (inputs.length) {
              inputs.forEach(input => input.checked = false);

              if (group.hasAttribute('data-selling-plan-require') && isAllowedGroup) {
                inputs[0].checked = true;
              }

              if (this.productForm.toggleAddButton) {
                this.productForm.toggleAddButton(false);
              }
            }
          });
        }
      }

      customElements.define('variant-selects', VariantSelects);

      class VariantRadios extends VariantSelects {
        constructor() {
          super();
        }

        updateOptions() {
          const fieldsets = Array.from(this.querySelectorAll('fieldset'));
          this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value || '';
          });
        }

        changeOptions(options) {
          const fieldsets = this.querySelectorAll('fieldset');

          options.forEach((optionValue, index) => {
            const inputs = fieldsets[index].querySelectorAll('input');

            inputs.forEach(input => {
              input.checked = input.value === optionValue;
            });
          });
        }
      }

      customElements.define('variant-radios', VariantRadios);
    }
  });
});
